export default __webpack_public_path__ + "static/media/coffee_Unlocked.5caf94dd.png";